import React, { useState } from 'react'
import { Card } from '@/components/ui'
import { QuickRankingSearch } from '@/components/QuickRankingSearch'
import { TopRankings } from '@/components/TopRankings'
import { Trophy, Globe, MapPin, Users } from 'lucide-react'

export function GlobalRankingsPage() {
  const [activeTab, setActiveTab] = useState<'global' | 'regional' | 'size_group'>('global')

  const tabs = [
    {
      id: 'global' as const,
      label: 'Общий рейтинг',
      icon: <Globe className="w-4 h-4" />,
      description: 'Рейтинг среди всех студий'
    },
    {
      id: 'regional' as const,
      label: 'По регионам',
      icon: <MapPin className="w-4 h-4" />,
      description: 'Рейтинг по странам/регионам'
    },
    {
      id: 'size_group' as const,
      label: 'По размеру города',
      icon: <Users className="w-4 h-4" />,
      description: 'Рейтинг по группам размера города'
    }
  ]

  return (
    <div className="space-y-6">
      {/* Заголовок страницы */}
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <Trophy className="w-8 h-8 text-primary" />
          <h1 className="text-2xl font-bold">Рейтинги студий</h1>
        </div>
        <p className="text-muted-foreground">
          Общие рейтинги всех студий по выручке за текущий месяц
        </p>
      </div>

      {/* Быстрый поиск */}
      <QuickRankingSearch />

      {/* Вкладки */}
      <Card>
        <div className="border-b border-border">
          <div className="flex">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
              >
                <div className="flex items-center justify-center gap-2">
                  {tab.icon}
                  <span>{tab.label}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="p-4">
          <div className="text-center mb-4">
            <p className="text-sm text-muted-foreground">
              {tabs.find(t => t.id === activeTab)?.description}
            </p>
          </div>

          <TopRankings 
            rankingType={activeTab} 
            limit={20}
          />
        </div>
      </Card>

      {/* Информация */}
      <Card>
        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Как формируются рейтинги?</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="space-y-2">
              <div className="flex items-center gap-2 font-medium">
                <Globe className="w-4 h-4 text-primary" />
                Общий рейтинг
              </div>
              <p className="text-muted-foreground">
                Позиция студии среди всех студий сети по общей выручке за месяц
              </p>
            </div>
            
            <div className="space-y-2">
              <div className="flex items-center gap-2 font-medium">
                <MapPin className="w-4 h-4 text-info" />
                По регионам
              </div>
              <p className="text-muted-foreground">
                Позиция среди студий в том же регионе (стране)
              </p>
            </div>
            
            <div className="space-y-2">
              <div className="flex items-center gap-2 font-medium">
                <Users className="w-4 h-4 text-muted-foreground" />
                По размеру города
              </div>
              <p className="text-muted-foreground">
                Позиция среди студий в городах схожего размера
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground">
              * Рейтинги обновляются ежедневно на основе данных о выручке студий. 
              Учитываются только студии с положительной выручкой за рассматриваемый период.
            </p>
          </div>
        </div>
      </Card>
    </div>
  )
}